import { patch } from '..';

const markNotificationsRead = (notificationId?: string, isRead: boolean = true) => {
  const body: {
    isRead: boolean, statusUpdateType: 'ALL' | 'BATCH', notificationIds?: string[],
  } = {
    isRead,
    statusUpdateType: notificationId ? 'BATCH' : 'ALL',
  };

  if (notificationId) body.notificationIds = [notificationId];
  return patch('button/notifications', body);
};

export default markNotificationsRead;
